import type { ReactNode } from 'react';

interface PanelProps {
  title: string;
  extra?: ReactNode;
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
}

export default function Panel({ title, extra, children, className = '', noPadding = false }: PanelProps) {
  return (
    <div className={`bg-white rounded-xl shadow-card border border-slate-100 h-full flex flex-col ${className}`}>
      <div className="flex items-center justify-between px-3.5 lg:px-[18px] py-3 lg:py-[14px] border-b border-slate-100 shrink-0">
        <h3 className="text-[13.5px] lg:text-[14.5px] font-semibold text-slate-900">{title}</h3>
        {extra && <div className="flex items-center gap-2">{extra}</div>}
      </div>
      <div className={`${noPadding ? '' : 'p-3.5 lg:p-5'} flex-1 min-h-0`}>{children}</div>
    </div>
  );
}
